import { isNil } from 'lodash'

import type { WithNonNullableProp } from '@/legacy-src/types/globals'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

type TherapistOfficeAvailability = Pick<TherapistType, 'hasOfflineTherapy' | 'office'>

export const isTherapistOfflineAvailable = (
  therapist: TherapistOfficeAvailability,
): therapist is WithNonNullableProp<TherapistOfficeAvailability, 'office'> => {
  return therapist.hasOfflineTherapy && !isNil(therapist.office)
}
